import React from "react";
import training from "../../assets/images/training01.jpg";
const HomePageJoinUs = () => {
  return (
    <div className=" z-10 w-full flex justify-center mt-6 pb-[120px] overflow-hidden items-center relative">
      <div className="absolute -bottom-1 rotate-180 w-full  " data-negative="false">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none" className="h-[150px] -z-10 block relative left-1/2 transform -translate-x-1/2" style={
            {
                width:"calc(198% + 1.3px)"
            }
          } 
        >
          <path
          
            opacity="0.33" fill="#D6ECE1"
            d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
          ></path>
          <path
           
            opacity="0.66" fill="#D6ECE1"
            d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
          ></path>
          <path
             fill="#D6ECE1"
            d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
          ></path>
        </svg>{" "}
      </div>
      <div className="xl:w-[75%] w-[90%] flex lg:flex-row flex-col justify-center lg:justify-between">
        <div className="lg:w-2/5 w-full felx justify-center items-center">
          <img src={training} alt="training" />
        </div>
        <div className="lg:w-[55%] w-full flex flex-col gap-4 md:pe-8 justify-center">
          <div className="text-2xl font-playfair text-[#CFA649]">
            {" "}
            Let's start{" "}
          </div>
          <span className="text-4xl text-[#17543E] font-bold font-playfair">
            Come as you are
          </span>
          <p className="text-[#525C58] text-lg leading-[34px] md:me-8 mb-4 font-raleway font-[400]">
            Inhale namaste mudra bandha goddess. Mudra rejuvenate ujjayi inhale
            kata Sana renew meditation in motion out of your comfort zone ground
            down paschimot tadasana. Breath of fire inhale hatha yoga,
            mindfulness engage.
          </p>
          <button className="text-[#CFA649] border-2 w-40 border-[#CFA649] rounded-[50px] hover:bg-[#CFA649] hover:text-white transition-all hover:duration-300 px-10 py-[8px] pt-[8px] pb-[10px] font-quicksand text-[20px] font-semibold capitalize">
            Join Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePageJoinUs;
